import script from "./MedicineDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./MedicineDrawer.vue?vue&type=script&setup=true&lang=js"

import "./MedicineDrawer.vue?vue&type=style&index=0&id=d148b8dc&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d148b8dc"]])

export default __exports__